import { ValuesSelectorSidebar } from '@upright/ui/common/upright/model/input/values-selector';
import { useValueSetSelectorAvailable } from '@upright/ui/common/generic/hooks';
import { Route, Routes } from 'react-router-dom';

export function ValuesSelectorMaybe() {
  /*
   * The sidebar is mounted closed, so leaving it in for someone who cannot open it is not a
   * visible bug — but it still ships the whole weights panel (four impact categories, twelve
   * radio rows) into the accessibility tree of every page, where a screen reader walks it.
   * Nothing opens it unless the value set is available, so nothing mounts it either.
   */
  const valueSetAvailable = useValueSetSelectorAvailable();
  if (!valueSetAvailable) {
    return null;
  }
  return (
    <Routes>
      <Route path="/share/:entityId" element={null} />
      <Route path="/render/*" element={null} />
      <Route path="/*" element={<ValuesSelectorSidebar pageWrapId="body-content" outerContainerId="outer-content" />} />
    </Routes>
  );
}
